import React, { useEffect, useState } from "react";
import { MapContainer, TileLayer, GeoJSON } from "react-leaflet";
import Geocomp from "./Geocomp";
import { IconButton, Stack, Button, Box, Tooltip } from "@mui/material";
import { ArrowForwardIos, TrendingUpRounded } from "@mui/icons-material";
import Legend from "../components/Legend";
import GetHighestNumber from "./GetHighestNumber";

function MapComponent(props) {
  const [map, setMap] = useState(undefined);

  // Pass selected country to parent component
  useEffect(() => {
    // props.selectedCountry(country)
    props.mapMinimalized(mapHidden);
  });

  // function to pull data from GeoJSON comp
  const pull_data = (data) => {
    props.selectedCountry(data);
  };

  function clickWM() {
    pull_data("none");
  }

  // Get minimalized state from button
  const [mapHidden, setMapHidden] = useState(false);

  const hideMap = () => {
    setMapHidden(true);
    setMap(undefined);
  };

  const showMap = () => {
    setMapHidden(false);
    // setMap(undefined)
  };

  const dataCount = JSON.parse(sessionStorage.getItem("countryMeasures"));
  const dataGeoJSON = JSON.parse(sessionStorage.getItem("getfullgeojson"));
  const countBorders =
    dataCount !== null ? GetHighestNumber(dataCount) : undefined;

  // If minimized, only show the button
  if (mapHidden)
    return (
      <Tooltip title="Show map">
        <Button
          variant="contained"
          aria-label="show map"
          onClick={showMap}
          sx={{ marginTop: 1, marginRight: 1 }}
        >
          VIEW MAP
        </Button>
      </Tooltip>
    );

  // Waits 100 ms, then reloads the map. This is necessary so the map component knows how big it should be.
  // Somehow it works. If it looks stupid but it works...
  setTimeout(function () {
    map.invalidateSize();
  }, 100);

  // Return map comp with button
  return (
    <Box border={1} height={"100%"}>
      <MapContainer
        center={[54.628911, 22.761347]}
        zoom={4}
        scrollWheelZoom={true}
        whenCreated={setMap}
        maxBounds={[
          [90, -90],
          [23.5, 90],
        ]}
      >
        {/* Minimization button overlaid on map */}
        <Stack
          sx={{
            position: "absolute",
            left: 10,
            top: 80,
            zIndex: "modal",
          }}
        >
          <Tooltip title="Hide map">
            <IconButton
              size="small"
              aria-label="Hide map"
              onClick={hideMap}
              sx={[
                {
                  backgroundColor: "background.secondary",
                  borderRadius: 1,
                  boxShadow: 2,
                  border: 1,
                },
                { "&:hover": { backgroundColor: "background.default" } },
              ]}
            >
              <ArrowForwardIos />
            </IconButton>
          </Tooltip>
        </Stack>

        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://tile.thunderforest.com/atlas/{z}/{x}/{y}.png?apikey=995435a6fd1e451080efd4c92b8b0a7c"
        />
        {map !== undefined ? (
          <Geocomp
            dataCount={dataCount}
            dataGeoJSON={dataGeoJSON}
            countBorders={countBorders}
            selectedCountry={pull_data}
            giveSelectedCountry={props.giveSelectedCountry}
          />
        ) : null}
        {countBorders !== undefined && map !== undefined ? (
          <Legend map={map} countBorders={countBorders} />
        ) : null}
        <GeoJSON
          key={"worldmap"}
          data={{
            type: "Feature",
            id: "wm",
            properties: { name: "wm" },
            geometry: {
              type: "Polygon",
              coordinates: [
                [
                  [180, 90],
                  [-180, 90],
                  [-180, -90],
                  [180, -90],
                  [180, 90],
                ],
              ],
            },
          }}
          style={{
            fillColor: "black",
            color: "",
            fillOpacity: 0,
            opacity: 0,
            zIndex: -50,
          }}
          onEachFeature={function onEachFeature(feature, layer) {
            layer.on({
              click: clickWM,
            });
          }}
        />
      </MapContainer>
    </Box>
  );
}

export default MapComponent;
